import { makeHttpRequest } from "@/shared";

export const deleteDelivery = async (id) => {
    return (
        await makeHttpRequest({
            url: `/delivery/${id}`,
            method: "DELETE",
        })
    ).data;
};
